import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const customsContent = {
  subtitle: "软件解决方案",
  title: "海关报关，进出口申报",
  description: [
    "在全球贸易的浪潮下，高效的海关报关与进出口申报流程至关重要。我们的软件解决方案帮助企业轻松处理各类海关事务，准确、高效地完成进出口申报，降低风险与成本，保障贸易合规无忧。",
    "向下滑动，探索我们针对不同场景打造的专业化产品，开启更顺畅、更智能的海关管理体验。",
  ],
  image: "/images/solutions/haiguan.png"
};

const customsProducts = {
  title: "我们的产品",
  subtitle: "房产数据分析解决方案",
  products: productsData.customsProducts
};

const Customs = () => {
  return (
    <div className="customs-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...customsContent} />
      <div style={{ backgroundColor: '#f8f9fa' }}>
        <ProductList {...customsProducts} />
      </div>
      <div className='mt-auto' style={{ backgroundColor: '#f8f9fa' }}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Customs; 